<div class="notification-container" *ngIf="showNotification">
    <div class="notification-header">
        <span class="icon">
            <i class="far fa-bell"></i>
        </span>
        <span class="notification-title">{{title}}</span>
        <button class="close-button" aria-label="Close" (click)="closeNoti()">&times;</button>
    </div>
    <div class="notification-body" (click)="navigateNoti()">
        <p>
            {{message}}
        </p>
        <p *ngIf="pdfurl">
            <i class="fas fa-paperclip mr-2"></i> <a
            [attr.href]="pdfurl">{{filename}}.pdf</a>
        </p>
        <a (click)="navigateHistory()" class="more-notifications" *ngIf="count-1>0">{{count-1}} more notifications</a>
    </div>
</div>

<nav #navbar class="navbar nav-mobile" [ngClass]="isNavbarShow ? 'active' : 'inactive'"
    [ngStyle]="{ 'position': showMobileAppOption ? 'relative' : 'fixed' }">
    <div class="container-fluid add_ht">
        <div class="navbar-header">
            <a href="#" onClick="return false;" class="navbar-toggle collapsed" data-toggle="collapse"
                data-target="#navbar-collapse" aria-expanded="false"></a>
            <!-- mobile menu bars -->
            <a href="#" onClick="return false;" class="bars" (click)="mobileMenuSidebarOpen($event,'overlay-open')"></a>
            <a class="navbar-brand">
                <!-- <img src="assets/images/logo_new.svg" alt="" height="30px" /> -->
                <span class="logo-name">
                    <img src="assets/images/logo_new.svg" class="name-logo" alt="" height="22px" />
                </span>
                <!-- incidents logo -->
                <!-- <span class="logo-name"><img src="assets/images/goaudits-incidents.svg" height="34px" alt="" style="top: 5px;
                    position: relative;" /></span> -->
            </a>
        </div>
        <div class="collapse navbar-collapse" id="navbar-collapse">
            <ul class="pull-left collapse-menu-icon">
                <li class="pull-left">
                    <button mat-icon-button (click)="callSidemenuCollapse()" class="sidemenu-collapse">
                        <mat-icon>menu</mat-icon>
                    </button>
                </li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
                <!-- Near Miss Raise Button -->
                <li class="near-miss-action" *ngIf="isNearMiss">
                    <button mat-raised-button color="primary" (click)="createNearMiss()">
                        <mat-icon>add</mat-icon>
                        Raise Near Miss
                    </button>
                </li>
                <li class="dropdown mr-2 dense-2 select_language"
                    [ngStyle]="{ 'color' : isNavbarShow ? '#fff' : '#333' }" *ngIf="isgp_flag">
                    <mat-form-field class="example-full-width lang_dd" appearance="outline" floatLabel="always"
                        [ngClass]="isNavbarShow ? 'custom-mat-field' : '' " style="font-size: 12px;margin-top:3%">
                        <mat-label>{{"Select village" | translate}}:</mat-label>
                        <mat-select [(value)]="selectedVillage" (selectionChange)='onVillageChange()'
                            [disabled]="!isAudits">
                            <ng-container *ngFor="let village of villageDetails">
                                <mat-option class="opt-change" [value]="village">
                                    {{village.account_name}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                </li>
                <li class="dropdown mr-2 dense-2 select_language"
                    [ngStyle]="{ 'color' : isNavbarShow ? '#fff' : '#333' }" *ngIf="enableMlFlag">

                    <!-- <div class="col-12 col-md-4"> -->
                    <mat-form-field class="example-full-width lang_dd" appearance="outline" floatLabel="always"
                        [ngClass]="isNavbarShow ? 'custom-mat-field' : '' " style="font-size: 12px;margin-top:3%">
                        <mat-label>{{"Select Language" | translate}}:</mat-label>
                        <mat-select [(value)]="selectedlang" (selectionChange)='onselectLanguage($event)'>
                            <ng-container *ngFor="let lang of supportLanguages">
                                <mat-option *ngIf="lang?.lang_code" class="opt-change" [value]="lang.lang_code">
                                    {{lang.lang_name}}
                                </mat-option>
                            </ng-container>
                        </mat-select>
                    </mat-form-field>
                    <!-- </div> -->
                </li>
                <li *ngIf="notiflag">
                    <button [ngStyle]="{ 'color' : isNavbarShow ? '#fff' : '#333' }"
                        [ngClass]="notificationCount>0 ? 'bellicon' : 'belliconpla'"
                        [attr.data-content]="notificationCount" (click)="gotoNotiHist()">
                        <i class="far fa-bell"></i>
                    </button>
                </li>
                <li [ngStyle]="{ 'color' : isNavbarShow ? '#fff' : '#333' }" *ngIf="userName">{{'welcome' | translate}},
                    <span>{{userName}}</span>
                </li>
                <li class="dropdown user_profile">
                    <a href="#" onClick="return false;" data-toggle="dropdown" role="button"
                        class="user-profile-icon pt-0">
                        <img src="assets/images/user.jpg" class="rounded-circle" width="32" height="32" alt="User">
                    </a>
                    <ul class="dropdown-menu dropdown pullDown">
                        <li class="body">
                            <ul class="user_dw_menu">
                                <li>
                                    <a href="javascript:void(0)" (click)="logout()">
                                        <mat-icon aria-hidden="false"
                                            class="mr-2">power_settings_new</mat-icon>{{'Logout' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</nav>